// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FilterBar div.filter-box[data-v-ed8f05be]{flex:1 1;max-width:300px}", ""]);
// Exports
module.exports = exports;
